import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ReviewFormBuilder from "@/modules/performance/admin/components/review-form/ReviewFormBuilder";
import { fetchReviewFormQueryOptions } from "@/modules/performance/admin/services";

const searchSchema = z.object({
  step: z.number().optional(),
});

export const Route = createFileRoute(
  "/admin/_panel/_performance/performance/reviews/forms/$id",
)({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "performance.performance-review-form.update",
    );

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Edit Question", {
            ns: "performance.admin",
          }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchReviewFormQueryOptions(opts.params.id),
    ),
});

function Component() {
  const { id } = Route.useParams();

  return <ReviewFormBuilder id={id} />;
}
